import { Box, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFieldsStart } from "../../store/features/customer/fields/fieldsSlice";
import ToolForm from "../../components/forms/toolsForm/toolForm.component";
import { useIsMobile } from "../../hook/useIsMobile";

const AddToolPage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useIsMobile();

  const accessToken = useSelector((state) => state.auth?.user?.access_token);

  useEffect(() => {
    dispatch(fetchFieldsStart({ accessToken }));
  }, [accessToken, dispatch]);

  return (
    <Box width="100%" height="100%" display="flex" flexDirection="column">
      <ToolForm theme={theme} isMobile={isMobile} accessToken={accessToken} />
    </Box>
  );
};
export default AddToolPage;
